import _ from 'lodash';

function findAddPageAction<T>(actions: T[]): T {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line you-dont-need-lodash-underscore/find
  return _.find(actions, ['type', 'add_page']);
}

export { findAddPageAction };
